import { InjectionToken } from '@angular/core';

export const PLATFORM_API_URL = new InjectionToken<string>('PLATFORM_API_URL');
export const GATEWAY_URL = new InjectionToken<string>('GATEWAY_URL');
